var exports = {
  "G": "bodyText__u4FoAt",
  "k": "errorText__iSxAmX",
};

module.exports = exports;
